/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @version 1.19.0
 * @since 1.19.0
 */

import { icons } from '../../../assets';

export const getInquiryStatusIcon = (statusId: number): string => {
    switch (statusId) {
        case 1:
            return icons.processStatusIcon;
        case 0:
            return icons.waiting;
        case 3:
            return icons.errorStatusIcon;
        case 4:
            return icons.halfStatusIcon;
        case 5:
            return icons.doneStatusIcon;
        default:
            return '';
    }
};
